if (!customElements.get('product-recommendations')) {
	/**
	 *  @class
	 *  @function ProductRecommendations
	 */
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			this.parent = this.closest('.product-recommendations--parent');
		}
		markLoaded(hasContent = false) {
			if (hasContent && this.parent) {
				this.parent.classList.add('product-recommendations--full');

				if (document.body.classList.contains('open-cart')) {
					this.parent.classList.add('active');
				}
			}

			this.classList.add('product-recommendations--loaded');
		}
		fetchProducts() {
			if (this.innerHTML.trim().length) {
				this.markLoaded(true);
				return;
			}

			if (!this.dataset.url) {
				this.markLoaded(false);
				return;
			}

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
						this.markLoaded(true);
						return;
					}

					this.markLoaded(false);
				})
				.catch(e => {
					console.error(e);
					this.markLoaded(false);
				});
		}
		connectedCallback() {
			this.fetchProducts();
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}
